import React, { useCallback, useContext, useState } from 'react';
import { Button, Grid } from '@material-ui/core';


import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { StreamMeta, UploadRecordContext } from '../../record/UploadRecordContext';
import RecordingItem from './RecordingItem';
import useStyles from './styles';
import { CircleIcon } from '../../../icon/solid';
import { selectCameraRecording } from '../../../../store/modules/studio/selectors';
import StudioModal from '../../StudioModal';
import { studioModalStyles } from '../../styles';
import StudioToolTip from "../../actions/StudioToolTip";

// import streamDataDev from "./devData";

const RecordingList = () => {
  const classes = useStyles();
  const studioClasses = studioModalStyles();
  const { streamData, cancel } = useContext(UploadRecordContext);
  const isRecording = useSelector(selectCameraRecording);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);
  const openDeleteModalHandler = useCallback(() => setOpenDeleteModal(true), [setOpenDeleteModal]);
  const closeDeleteModalHandler = useCallback(() => setOpenDeleteModal(false), [setOpenDeleteModal]);
  const [removingStream, setRemovingStream] = useState<StreamMeta|null>(null);
  const setArticleCb = useCallback((stream : StreamMeta) => (e: React.MouseEvent) => {
    setRemovingStream(stream);
    openDeleteModalHandler();
    e.stopPropagation();
  },
  [openDeleteModalHandler]);

  const deleteArticle = useCallback((e: React.MouseEvent) => {
    if (removingStream) {
      cancel(removingStream);
    }
    closeDeleteModalHandler();
    setRemovingStream(null);
    e.stopPropagation();
  },
  [closeDeleteModalHandler, removingStream, cancel]);


  return (
    <>
      <StudioModal
        open={openDeleteModal}
        title="Are you sure you want to delete this recording?"
        onClose={closeDeleteModalHandler}
        text="Choosing delete will permanently delete this recording"
      >
        <Grid container alignItems="center" justify="space-between">
          <Button className={clsx(studioClasses.button, 'cancel-neutral')} onClick={closeDeleteModalHandler}>
            Cancel
          </Button>
          <Button className={clsx(studioClasses.button, 'confirm')} onClick={deleteArticle}>
            Delete
          </Button>
        </Grid>
      </StudioModal>
      <StudioToolTip title={'List of recordings made since Studio mode was started'}>
        <Grid item style={{ width: '100%' }}>
          <p className={classes.label}>Recordings</p>
          <Grid item container className={classes.recordingList}>
            <Grid
              item
              container
              alignItems="center"
              className={classes.preview}
              style={{ display: isRecording ? 'flex' : 'none' }}
            >
              <Grid container alignItems="center" justify="center" className={classes.recordingIcon}>
                <CircleIcon className="circle" />
              </Grid>
              <span>Recording</span>
            </Grid>
            {streamData.length || isRecording
              ? streamData.map((item) => (
                <RecordingItem
                  openDeleteModal={setArticleCb}
                  stream={item}
                  key={item.id}
                />
              )) : 'None'}
          </Grid>
        </Grid>
      </StudioToolTip >
    </>
  );
};

export default RecordingList;
